var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsDetailsArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93 11c.145.004.287-.02.42-.072.264-.104.47-.31.574-.575.052-.132.076-.275.072-.42l-.238-7.765a1.183 1.183 0 0 0-.583-.952 1.1 1.1 0 0 0-1.086-.033c-.331.182-.531.53-.526.918l.156 5.116L1.851.346A1.146 1.146 0 0 0 .78.029 1.01 1.01 0 0 0 .03.782c-.09.376.031.783.317 1.07l6.868 6.87-5.112-.156a1.02 1.02 0 0 0-.918.526c-.181.33-.169.744.033 1.087.203.343.564.564.952.583l7.761.237z",
    fill: "#0057A0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsDetailsArrow);
export default __webpack_public_path__ + "static/media/reports-details-arrow.02b435301a3551697c16adcc98d66afd.svg";
export { ForwardRef as ReactComponent };